import React from "react";
import { useNavigate } from "react-router-dom";


const PageNotFound = () => {
    const navigate = useNavigate();

    return (
        <>


<section className='py-5 text-center'>
<div className='container align-content-center'>

<p>Oops! Page not Found.</p>

<button className="bg-success border-0 outline-0 py-2 px-3 rounded-pill text-light fw-bold" onClick={() => navigate('/')}>Click Here</button>


</div>
    </section>

</>
    )}


export default PageNotFound;